import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrLastModifiedDate = createSelector(
  [selectQbrState],
  ({ lastModified }) => lastModified
)
